/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgBattery56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        d='M32.03 1.405L30.97.345 23.564 7.75h6.125l-4.844 4.845 1.06 1.06 7.406-7.405h-6.125l4.844-4.845zM15.875 28v3.625H12.25v1.5h3.625v3.625h1.5v-3.625H21v-1.5h-3.625V28h-1.5zM43.75 33.125H35v-1.5h8.75v1.5z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M20 15h-8.5v5.25h-7V55h47V20.25h-7V15H36v5.25H20V15zm30 6.75v20.5H6v-20.5h44zm-7-5.25v3.75h-5.5V16.5H43zm-24.5 3.75V16.5H13v3.75h5.5zM6 53.5v-9.75h44v9.75H6z'
      />
    </svg>
  );
}

export default SvgBattery56;
